export enum AxxessIntelligenceThumbEnum {
    None = 0,
    Up = 1,
    Down = 2
}
